import { render, staticRenderFns } from "./CAATProfile.vue?vue&type=template&id=4cbccec7&scoped=true"
import script from "./CAATProfile.vue?vue&type=script&lang=js"
export * from "./CAATProfile.vue?vue&type=script&lang=js"
import style0 from "./CAATProfile.vue?vue&type=style&index=0&id=4cbccec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbccec7",
  null
  
)

export default component.exports